/**
 * Created by shamim.ahsan on 6/13/2019.
 */
export class InboxModel{
  id:string;
  isDefault:boolean;
  order:number;
  title:string;
  type:string;
}
export class ReplyMessageModel{
  message:string;
  recipients:RecipientModel[];
  fileAttachments:FileAttachment[];
  mailThreadContentId:string;
}
export class RecipientModel{
  userName:string;
  firstName:string;
  lastName:string;
  email:string;
  companyId:string;
}
export class FileAttachment{
  attachedBy:string;
  attachedDate:Date;
  attachmentId:string;
  attachmentTitle:string;
  attachmentType:string;
}

